module.exports = __webpack_public_path__ + "static/img/David_Swallow_mobile.0540932.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/David_Swallow_mobile.jpg
// module id = c4Up
// module chunks = 0